import * as Sentry from "@sentry/react"
import confusedClouds from "assets/illustrations/confusedClouds.svg"
import forestLine from "assets/illustrations/forestLine.svg"
import { useEffect, type ReactNode } from "react"
import s from "./ErrorFallback.module.scss"

type ErrorFallbackProps = {
  title: ReactNode
  message?: ReactNode
  error: unknown | unknown[]
  featureTag?: string
}
export const ErrorFallback = ({
  title,
  message,
  error,
  featureTag,
}: ErrorFallbackProps) => {
  // TODO [sentry-logging] https://jira.attensi.com/browse/WEB-18745
  // Find a better place to send Sentry logs from
  useErrorSentryLog(error, featureTag)

  return (
    <div className={s.error} aria-live="polite">
      <div className={s.illustration}>
        <img src={confusedClouds} className={s.illustration__top} alt="" />
        <img src={forestLine} className={s.illustration__bottom} alt="" />
      </div>

      <div className={s.content}>
        <div className={s.content__title}>{title}</div>
        {message && <div className={s.content__message}>{message}</div>}
      </div>
    </div>
  )
}

// TODO [sentry-logging] https://jira.attensi.com/browse/WEB-18745
// Find a better place to send Sentry logs from
export const useErrorSentryLog = (
  error: unknown | unknown[],
  featureTag?: string
) => {
  useEffect(() => {
    // Put all the available errors in the array, so they can be iterated upon.
    // Also remove falsy errors to not send "null" to Sentry for no reason.
    const errorArray = (Array.isArray(error) ? error : [error]).filter(Boolean)
    for (const error of errorArray) {
      if (featureTag) {
        Sentry.setTag("feature", featureTag)
      }

      Sentry.captureException(error)
      console.error(error)
    }
  }, [error, featureTag])
}
